/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Construit le payload de mise à jour du panel « REGISTRE ET ACTE » de la
 * fiche acte, envoyé via `service.update` (PUT `/numerisation-actes/naissance/{identifiant}`).
 *
 * Contrairement à `buildActeNaissancePayload` (création), le registre est
 * renvoyé imbriqué (`acte.registre`), à l'identique de ce qui est reçu en
 * lecture dans la fiche — le back n'y attend pas les champs à plat
 * (`libelleRegistre`/`typeRegistre`/`anneeRegistre`) utilisés à la création.
 */
const buildRegistreActeUpdatePayload = (
  identifiant: number,
  data: Record<string, any>,
) => ({
  identifiant,
  acte: {
    identifiant,
    registre: data?.registre,
    identifiantSousTypeActe: data?.identifiantSousTypeActe,
    libelleTypeActe: data?.libelleTypeActe,
    // Renseigné pour la reconnaissance, dont le sous-type porte l'information
    // affichable ; absent (donc omis) pour la naissance.
    libelleSousTypeActe: data?.libelleSousTypeActe,
    dateDresseActe: data?.dateDresseActe,
    heureDresseActe: data?.heureDresseActe,
    minuteDresseActe: data?.minuteDresseActe,
    numeroActe: data?.numeroActe,
    numeroOrdre: data?.numeroOrdre,
    acteNumeroComplement: data?.acteNumeroComplement,
    /*
     * Officier d'état civil, propre au MARIAGE : `ec_actm` est la seule table à
     * porter ces colonnes.
     *
     * Les nommer inconditionnellement est sans effet ailleurs — la modale ne les
     * remplit que si elle affiche le sous-bloc, et une clé `undefined` disparaît
     * du JSON.
     */
    acteSignataireNomFamille: data?.acteSignataireNomFamille,
    acteSignatairePrenoms: data?.acteSignatairePrenoms,
    acteSignataireQualite: data?.acteSignataireQualite,
  },
});

export default buildRegistreActeUpdatePayload;
